// Position-volatility sparkline stroke color per spec §7D.
//   < 1.0  → green
//   < 2.5  → yellow
//   >= 2.5 → red

export function sparklineStroke(volatility) {
  if (volatility == null || Number.isNaN(Number(volatility))) return '#9CA3AF';
  const v = Number(volatility);
  if (v < 1.0) return '#22C55E';
  if (v < 2.5) return '#EAB308';
  return '#EF4444';
}
